var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-campaign-targeting-rule',[_c('div',[_vm._v("Visitors who have spent at least "+_vm._s(_vm.data / 1000)+" seconds on the site will see your message.")])])}
var staticRenderFns = []

export { render, staticRenderFns }